<template>
  <form @submit.prevent="$emit('submit', channel)" class="form" method="post">
    <div class="form-wrap">
      <label for="email">{{ $t('notifications.email') }}</label>
      <input v-model="channel.email" class="form-input" type="text" name="email" id="email" required />
    </div>

    <p style="margin: 0">
      <input type="submit" :value="submitText" class="button button-green button-round" />
    </p>
  </form>
</template>

<script>
export default {
  components: {},
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      channel: { ...this.value },
    }
  },
  watch: {
    value: {
      handler(channel) {
        this.channel = { ...channel }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    submitText() {
      if (this.channel.uuid) {
        return `${this.$t('notifications.updateChannel')} ›`
      } else {
        return `${this.$t('notifications.createChannel')} ›`
      }
    },
  },
}
</script>

<style lang="scss"></style>
